__turbopack_context__.v({
  "actions": "public-pages-module__XM07mG__actions",
  "card": "public-pages-module__XM07mG__card",
  "closing": "public-pages-module__XM07mG__closing",
  "container": "public-pages-module__XM07mG__container",
  "directory": "public-pages-module__XM07mG__directory",
  "eyebrow": "public-pages-module__XM07mG__eyebrow",
  "hero": "public-pages-module__XM07mG__hero",
  "heroImage": "public-pages-module__XM07mG__heroImage",
  "icon": "public-pages-module__XM07mG__icon",
  "intro": "public-pages-module__XM07mG__intro",
  "link": "public-pages-module__XM07mG__link",
  "modules": "public-pages-module__XM07mG__modules",
  "note": "public-pages-module__XM07mG__note",
  "page": "public-pages-module__XM07mG__page",
  "pricing": "public-pages-module__XM07mG__pricing",
  "section": "public-pages-module__XM07mG__section",
  "segments": "public-pages-module__XM07mG__segments",
  "soft": "public-pages-module__XM07mG__soft",
  "step": "public-pages-module__XM07mG__step",
  "stepNumber": "public-pages-module__XM07mG__stepNumber",
  "steps": "public-pages-module__XM07mG__steps",
});
